<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.machineCode" clearable placeholder="编码" style="width:150px" @keyup.enter.native="search" />
      <el-input v-model="query.machineName" clearable placeholder="名称" style="width:150px" @keyup.enter.native="search" />
      <el-select v-model="query.machineStatus" clearable placeholder="状态" style="width:120px">
        <el-option label="运行" value="01" />
        <el-option label="停用" value="02" />
        <el-option label="维修中" value="03" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="machineCode" label="编码" width="140" />
      <el-table-column prop="machineName" label="名称" min-width="160" />
      <el-table-column prop="productionLineName" label="产线" width="140" />
      <el-table-column prop="serialNo" label="序列号" width="140" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="statusType(row.machineStatus)">{{ statusLabel(row.machineStatus) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.machineId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.machineId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="form.machineId ? '修改设备' : '新增设备'" :visible.sync="visible" width="860px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px">
        <el-row :gutter="12">
          <el-col :span="12"><el-form-item label="编码"><el-input v-model="form.machineCode" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="名称"><el-input v-model="form.machineName" /></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="产线">
              <el-select v-model="form.productionLineId" filterable clearable style="width:100%">
                <el-option v-for="l in lines" :key="l.lineId" :label="l.lineName" :value="l.lineId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"><el-form-item label="序列号"><el-input v-model="form.serialNo" /></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-select v-model="form.machineStatus" style="width:100%">
                <el-option label="运行" value="01" />
                <el-option label="停用" value="02" />
                <el-option label="维修中" value="03" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24"><el-form-item label="说明"><el-input v-model="form.description" type="textarea" :rows="2" /></el-form-item></el-col>
        </el-row>
        <el-button type="primary" size="mini" @click="addSpare">添加备件</el-button>
        <el-table :data="form.spareList" border size="small" style="margin-top:8px">
          <el-table-column label="产品" min-width="220">
            <template slot-scope="{ row }">
              <el-select v-model="row.productId" filterable size="mini" style="width:100%">
                <el-option v-for="p in products" :key="p.productId" :label="p.productNumber + ' / ' + (p.productName || '')" :value="p.productId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="定额" width="140">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.qtyNorm" :min="0" :precision="4" size="mini" style="width:100%" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70" align="center">
            <template slot-scope="{ $index }">
              <el-button type="text" size="mini" @click="form.spareList.splice($index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listMachine, getMachine, saveMachine, updateMachine, deleteMachine } from '../../api/machine'
import { selectProductionLine } from '../../api/productionLine'
import { selectProduct } from '../../api/product'

function emptyForm() {
  return {
    machineId: '', machineCode: '', machineName: '', productionLineId: '', serialNo: '',
    machineStatus: '01', description: '', spareList: []
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { machineCode: '', machineName: '', machineStatus: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false,
      form: emptyForm(), lines: [], products: []
    }
  },
  created() {
    this.load()
    selectProductionLine().then(res => { this.lines = res.data || [] }).catch(() => {})
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
  },
  methods: {
    statusLabel(v) { return { '01': '运行', '02': '停用', '03': '维修中' }[v] || v },
    statusType(v) { return { '01': 'success', '02': 'info', '03': 'warning' }[v] || 'info' },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listMachine({
        currentPage: this.page, pageSize: this.pageSize,
        machineCode: this.query.machineCode, machineName: this.query.machineName, machineStatus: this.query.machineStatus
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    addSpare() { this.form.spareList.push({ productId: '', qtyNorm: 1 }) },
    openEdit(id) {
      if (!id) {
        this.form = emptyForm()
        this.visible = true
        return
      }
      getMachine(id).then(res => {
        const d = res.data || {}
        this.form = {
          machineId: d.machineId, machineCode: d.machineCode, machineName: d.machineName,
          productionLineId: d.productionLineId || '', serialNo: d.serialNo || '',
          machineStatus: d.machineStatus || '01', description: d.description || '',
          spareList: (d.spareList || []).map(s => ({ productId: s.productId, qtyNorm: Number(s.qtyNorm || 1) }))
        }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.machineCode || !this.form.machineName) { this.$message.warning('请填写编码和名称'); return }
      const spareList = (this.form.spareList || []).filter(s => s.productId)
      this.saving = true
      const payload = { ...this.form, spareList }
      const req = this.form.machineId ? updateMachine(payload) : saveMachine(payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteMachine([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
